import React from 'react';
import { Paper, Icon, Typography, Divider, List, ListItem, ListItemText } from '@material-ui/core';
import { FuseAnimate } from '@fuse';
import { makeStyles } from '@material-ui/core/styles';
import QueueTable from '../../QueueTable';

const useStyles = makeStyles(theme => ({
	listItem: {
		color: 'secondary',
		textDecoration: 'none!important',
		height: 40,
		paddingLeft: 24,
		paddingRight: 12,
		'&.active': {
			backgroundColor: theme.palette.secondary.main,
			color: theme.palette.secondary.contrastText + '!important',
			pointerEvents: 'none',
			'& .list-item-icon': {
				color: 'inherit'
			}
		},
		'& .list-item-icon': {
			marginRight: 16
		}
	},
	selectedItem: {
		color: 'secondary',
		textDecoration: 'none!important',
		height: 40,
		paddingLeft: 24,
		paddingRight: 12,
		backgroundColor: '#f2f2f2',
		'&.active': {
			backgroundColor: theme.palette.secondary.main,
			color: theme.palette.secondary.contrastText + '!important',
			pointerEvents: 'none',
			'& .list-item-icon': {
				color: 'inherit'
			}
		},
		'& .list-item-icon': {
			marginRight: 16
		}
	},
}));

const QueueTab = ({ 
	queue, 
	queueFilter, 
	selectedItem, 
	jobStatusFilters 
}) => {
	const classes = useStyles();


	if (!queue) return null;

	return (
		<div className="w-full flex flex-row items-start justify-between">
			<div className="p-0 lg:p-24 lg:pr-4 w-1/4">
				<FuseAnimate animation="transition.slideLeftIn" delay={200}>
					<Paper className="rounded-0 shadow-none lg:rounded-8 lg:shadow-1">
						<div className="flex items-center px-16 h-64 border-b-1">
							<Icon className="text-black text-20 pr-56">list</Icon>
							<Typography className="text-16 font-bold">Workload</Typography>
						</div>
						<Divider />
						<List>
							{jobStatusFilters.map(item => (
								<ListItem
									key={item.id}
									id={item.id}
									button
									onClick={() => {
										if (item.onClick) {
											item.onClick();
										}
									}}
									className={`${classes.listItem} ${selectedItem === item.id ? classes.selectedItem + ' active' : ''}`}
								>
									<Icon className={`list-item-icon text-16 ${item.iconColor}`} color="action">
										{item.icon}
									</Icon>
									<ListItemText className="truncate pr-0 font-bold" primary={item.text} disableTypography={true} />
									<ListItemText
										id={`queue-list-data-${item.id}`}
										className="flex justify-end font-bold"
										primary={item.primaryData}
										disableTypography={true}
									/>
								</ListItem>
							))}
						</List>
					</Paper>
				</FuseAnimate>
			</div>
			<div className="p-16 sm:p-24 w-3/4">
				<QueueTable queue={queue} filter={queueFilter} />
			</div>
		</div>
	);
};

export default QueueTab;
